<h2 mat-dialog-title>{{id? 'Update Ticket' : 'Add Ticket'}}</h2>
<form [formGroup]="ScanningForm" (ngSubmit)="onFormSubmit()">
    <mat-dialog-content class="content">

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Row</mat-label>
                <input [ngModel]="row" formControlName="row" matInput placeholder="Enter Row">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Seat No</mat-label>
                <input type="number" [ngModel]="seat_no" formControlName="seat_no" matInput placeholder="Enter Seat No">
            </mat-form-field>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button type="submit" color="primary">{{id? 'Update' : 'Add'}}</button>
    </mat-dialog-actions>
</form>